import React from 'react';

import { Tooltip, Box, IconButton, Typography, Link } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import BusinessIcon from '@material-ui/icons/Business';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';

import DateFnsUtils from '@date-io/date-fns';

import { useDispatch } from 'react-redux';
const dateFns = new DateFnsUtils();

interface IProps {
    readonly category?: string;
    readonly categoryAggregate?: string;
    readonly color?: string;
    readonly date?: string | null;
    readonly company: string;
    readonly address?: string;
    readonly titleNos: string[];
    readonly url?: string;
    readonly isLandAssembly: boolean;
    readonly handlePurchaseTitleDeedClick: (titles: string[]) => void;
}

function SiteOwnershipCard({
    category,
    categoryAggregate,
    color,
    date,
    company,
    address,
    titleNos,
    url,
    isLandAssembly,
    handlePurchaseTitleDeedClick
}: IProps) {
    const classes = useStyles();
    const dispatch = useDispatch<any>();
    return (
        <div className={classes.root}>
            <div className={classes.icon}>
                <BusinessIcon />
            </div>
            <div className={classes.infoContainer}>
                {category && categoryAggregate ? (
                    <div className={classes.topRow}>
                        <Tooltip arrow title={category} placement="bottom">
                            <Typography
                                className={classes.chip}
                                style={{
                                    color: color,
                                    background: `${color}33`
                                }}>
                                {categoryAggregate}
                            </Typography>
                        </Tooltip>
                        {Boolean(url) && (
                            <Link href={url} target="_blank">
                                <Tooltip arrow title="View on Companies House" placement="right">
                                    <Box color="primary.light">
                                        <IconButton color="inherit" size="small" onClick={() => {}}>
                                            <ExitToAppIcon />
                                        </IconButton>
                                    </Box>
                                </Tooltip>
                            </Link>
                        )}

                        <div className={classes.dateInfo}>
                            <Typography variant="caption">
                                {date
                                    ? `Proprietor added ${dateFns.format(
                                          dateFns.parse(date, 'yyyy-MM-dd'),
                                          'dd/MM/yyyy'
                                      )}`
                                    : null}
                            </Typography>
                            {isLandAssembly && (
                                <div className={classes.purchaseDeed}>
                                    <div className={classes.iconDeed}>
                                        <ShoppingCartIcon fontSize="inherit" color="inherit" />
                                    </div>
                                    <div
                                        onClick={() => handlePurchaseTitleDeedClick(titleNos)}
                                        className={classes.deedLink}>
                                        <Typography variant="body2">Purchase title deed</Typography>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                ) : null}
                {Boolean(titleNos) && <Typography>{titleNos.join(', ')}</Typography>}
                <Typography className={classes.company}>{company}</Typography>
                {address ? <Typography variant="body2">{address}</Typography> : null}
            </div>
        </div>
    );
}

const useStyles = makeStyles((theme: any) => ({
    root: {
        display: 'flex',
        border: `1px solid ${theme.palette.background.border}`,
        borderRadius: '5px',
        position: 'relative',
        color: theme.palette.text.primary,
        fontWeight: 500,
        fontSize: '11px',
        padding: '15px'
    },
    topRow: {
        display: 'flex',
        alignItems: 'center',
        '&> *:first-child': {
            color: theme.palette.text.secondary
        },
        '&> *:last-child': {
            marginLeft: 'auto'
        }
    },
    icon: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0px 20px',
        marginRight: '15px'
    },
    infoContainer: {
        flexGrow: 1,
        overflow: 'hidden',
        '&> *:not(:last-child)': {
            marginBottom: 5
        }
    },
    company: {
        // margin: '5px 0px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    },
    chip: {
        ...theme.typography.chip,
        textTransform: 'uppercase',
        padding: '0px 6px'
    },
    dateInfo: {
        position: 'absolute',
        top: 16,
        right: 16
    },
    purchaseDeed: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'end',
        color: theme.palette.primary.light
    },
    iconDeed: {
        display: 'flex',
        alignItems: 'center',
        fontSize: 14,
        marginRight: 4,
        color: theme.palette.primary.light
    },
    deedLink: {
        textDecoration: 'none',
        cursor: 'pointer'
    }
}));

export default SiteOwnershipCard;
